import { render, staticRenderFns } from "./SectionDivider.vue?vue&type=template&id=4d83dcc4&scoped=true"
import script from "./SectionDivider.vue?vue&type=script&lang=js"
export * from "./SectionDivider.vue?vue&type=script&lang=js"
import style0 from "./SectionDivider.vue?vue&type=style&index=0&id=4d83dcc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83dcc4",
  null
  
)

export default component.exports